export enum ROUTE_PATH {
  SHIELD_STARTER_DEFAULT_HOME_ROUTE = "/shieldstarter/",
  SHIELD_STARTER_GENERIC_ERROR = "/shieldstarter/error",
  SHIELD_STARTER_CONNECTION_ERROR = "/shieldstarter/connection-error",
  SHIELD_STARTER_GET_QUOTE = "/shieldstarter/get-quote",
  SHIELD_STARTER_CHOOSE_PLAN = "/shieldstarter/choose-plan",
  SHIELD_STARTER_VIEW_QUOTATION = "/shieldstarter/choose-plan/view-quotation",
  SHIELD_STARTER_MAILING_ADDRESS = "/shieldstarter/mailingaddress",
  SHIELD_STARTER_START_APPLICATION = "/shieldstarter/start-application",
  SHIELD_STARTER_HEALTH_DECLARATION = "/shieldstarter/health-declaration",
  SHIELD_STARTER_REVIEW = "/shieldstarter/review",
  SHIELD_STARTER_SINGPASS_PERSMISSION = "/shieldstarter/singpass",
  SHIELD_STARTER_MY_INFO = "/shieldstarter/my-info",
  SHIELD_STARTER_DECLARATION = "/shieldstarter/health-declaration/declaration",
  SHIELD_STARTER_CONTACT_US = "/shieldstarter/contact-form",
  SHIELD_STARTER_ADVISER = "/shieldstarter/adviser",
  SHIELD_STARTER_COFIRMATION = "/shieldstarter/confirmation",
  SHIELD_STARTER_PAYMENT = "/shield-starter/payment",
  MLTC_HEALTH = "/mltc/health",
  MLTC_CONTACT_US = "/mltc/contact-form",
  MLTC_MY_INFO = "/mltc/my-info",
  MLTC_LETS_GET_STARTED = "/mltc/lets-get-started",
  EVER_GREEN_MY_INFO = "/evergreen/my-info",
  EVER_GREEN_CONTACTUS = "/evergreen/contactus",
  EVER_GREEN_OCCUPATION = "/evergreen/occupation",
  EVER_GREEN_SINGPASS = "/evergreen/singpass",
  EVER_GREEN_MAILING_ADDRESS = "/evergreen/mailingaddress",
  EVER_GREEN_FINANCIAL_ADVISER = "/evergreen/adviser",
  EVER_GREEN_PEP = "/evergreen/pep",
  EVER_GREEN_GET_STARTED = "/evergreen/get-started",
  EVER_GREEN_TAX_DECLARATION = "/evergreen/tax-declaration",
  EVER_GREEN_QUOTATION = "/evergreen/quote",
  EVER_GREEN_DOCUMENT_REVIEW = "/evergreen/document-review",
  EVER_GREEN_PAYMENT = "/evergreen/payment",
  EVER_GREEN_THANK_YOU = "/evergreen/thank-you",
  EVER_GREEN_REVIEW = "/evergreen/review",
  EVER_GREEN_VIEW_QUOTE = "/evergreen/view-quote",
  EVER_GREEN_LANDING_PAGE = "https://singlife.com/en/savings/digital-saver",
  EVER_GREEN_FAST_PAYMENT = "/evergreen/fast-payment",
  EVER_GREEN_ARC = "/evergreen/arc",
  FAST_BANK_COLLECTION_CALLBACK_HANDLER = "/collection/callback",
  EVER_GREEN_PAY_NOW = "/evergreen/paynow",
  CANCER_COVER_BASIC_INFO = "/ccp/basic-info",
  CANCER_COVER_LANDING_PAGE = "/ccp/product",
  CANCER_COVER_QUOTATION_SUMMARY = "/ccp/quotation-summary",
  CANCER_COVER_UW_3 = "/ccp/under-writing-3",
  CANCER_COVER_UW_2 = "/ccp/under-writing-2",
  CANCER_COVER_UW_1A = "/ccp/under-writing-1a",
  CANCER_COVER_UW_1B = "/ccp/under-writing-1b",
  CANCER_COVER_CONTACT_US = "/ccp/contactus",
  CANCER_COVER_SINGPASS = "/ccp/singpass",
  CANCER_COVER_DECLARATION = "/ccp/declaration",
  CANCER_COVER_FINANCIAL_ADVISER = "/ccp/far",
  CANCER_COVER_MY_INFO = "/ccp/my-info",
  CANCER_COVER_USER_DECLARATION = "/ccp/user-declaration",
  CANCER_COVER_PAYMENT = "/ccp/payment",
  CANCER_COVER_MAILING_ADDRESS = "/ccp/mailing-address",
  CANCER_COVER_REVIEW = "/ccp/review",
  CANCER_COVER_PAYMENT_SUCCESS = "/ccp/confirmation",
}
